<template>
  <el-dialog
  class="ModalMove"
  :show-close="false"
  :visible="visible"
  :before-close="handleClose"
  v-loading="folderBusy">
    <div
    slot="title"
    class="ModalMove__header">
      <span class="ModalMove__title">Choose destination folder</span>
      <div
      class="ModalMove__new-folder"
      @click="createNewFolder">
        <SvgImage
        imageName="NewFolderActive"/>
      </div>
    </div>
    <div class="ModalMove__body scrollbar-container">
      <div
      v-if="canGoUp"
      class="ModalMove__element"
      @click="goUp">
        <div class="ModalMove__icon"
        :style="{ 'background-image': 'url(/images/folder-up.png)'}"/>
        <span class="ModalMove__name">Go up</span>
      </div>
      <div
      v-for="folder in folders"
      :key="folder.id"
      class="ModalMove__element"
      @click="changeFolder(folder)" >
        <div class="ModalMove__icon"
        :style="{ 'background-image': 'url(/images/placeholder-folder.png)'}"/>
        <span class="ModalMove__name">{{folder.name}}</span>
      </div>
    </div>
    <span
    slot="footer"
    class="ModalMove__footer">
      <el-button
      type="text"
      @click="handleClose">
        Cancel
      </el-button>
      <el-button
      :disabled="moveDisabled"
      type="primary"
      class="ModalMove__btn-primary"
      @click="moveThisFile">
        Move
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ModalMove',

  data () {
    return {
      folderId: 'root'
    }
  },

  computed: {
    ...mapGetters('modal', [
      'visibleByModal',
      'fileByModal'
    ]),
    ...mapGetters('filesFolder', [
      'folderBusy',
      'folderById'
    ]),
    file () {
      return this.fileByModal('move')
    },
    visible () {
      return this.visibleByModal('move')
    },
    currentFolder () {
      const id = this.folderId
      return this.folderById(id)
    },
    folders () {
      return this.currentFolder ? this.currentFolder.files.filter(f => {
        return f.type === 5 && f.id !== this.file.id
      }) : []
    },
    canGoUp () {
      return this.currentFolder.folderInfo.name
    },
    moveDisabled () {
      if (this.file.parentItemId) {
        return this.folderId === this.file.parentItemId
      } else {
        return this.folderId === 'root'
      }
    }
  },

  watch: {
    visible (visible) {
      if (visible) {
        this.getUserFiles()
      } else {
        this.folderId = 'root'
      }
    },
    folderId (folderId) {
      if (!this.visible) return

      if (folderId === 'root') this.getUserFiles()
      else this.getFolderFiles({ folderId })
    }
  },

  methods: {
    ...mapActions('modal', [
      'hideModal'
    ]),
    ...mapActions('files', [
      'moveFile'
    ]),
    ...mapActions('filesFolder', [
      'createFolder',
      'getFolderFiles',
      'getUserFiles',
      'moveFolder'
    ]),
    createNewFolder () {
      this.$prompt('', 'Create New Folder', {
        confirmButtonText: 'Create',
        cancelButtonClass: 'el-button--text',
        cancelButtonText: 'Cancel',
        inputPattern: /.$/,
        inputErrorMessage: 'Cannot be empty',
        showClose: false
      }).then(({ value }) => {
        let name = value.trim()
        if (name) {
          let parentItemId = this.folderId === 'root' ? undefined : this.folderId
          this.createFolder({ name, parentItemId })
        }
      }).catch(() => {})
    },
    changeFolder (folder) {
      this.folderId = folder.id
    },
    goUp () {
      this.folderId = this.currentFolder.folderInfo.parentItemId || 'root' // do to not leave blank
    },
    handleClose () {
      this.hideModal('move')
    },
    moveThisFile () {
      if (this.file.type === 5) {
        const payload = {
          folder: this.file,
          parentItemId: this.folderId
        }
        this.moveFolder(payload)
      } else {
        const payload = {
          file: this.file,
          parentItemId: this.folderId
        }
        this.moveFile(payload)
      }
    }
  }
}
</script>

<style lang="scss">
@import 'ModalMove';
</style>
